export type IAuthenticationMethod = AuthenticationMethod;
export enum AuthenticationMethod {
  cookie = "cookie",
  jwt = "jwt",
  key = "key",
  tokenHeader = "tokenHeader",
  none = "none",
}
